import { validateStringEnum } from "../../../../packages/validator/validator.js";

/**
 * Possible effects on account balance by the item.
 */
export type ItemAccountEffect = "debit" | "credit" | "both" | "none";

export const validateItemAccountEffect = validateStringEnum(["debit", "credit", "both", "none"]);
